<template>
  <v-dialog v-model="dialog" persistent width="950">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id_cargo ? "edit" : "add" }}</v-icon>
          {{ form.id_cargo ? "Modificar Cargo" : "Crear Cargo" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12 xs12>
                <v-text-field
                  label="Cargo"
                  v-model="form.denominacion"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field
                  label="Haber básico en Bs."
                  v-model="form.haber_basico"
                  :rules="$validate(['required'])"
                  required
                  type="number"
                  outline
                  success
                  clearable
                ></v-text-field>
                <small
                  >* Adicione un punto(.) ,solo si desea ingresar ctvs. Ejm:
                  10400.50</small
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
    };
  },
  mounted() {
    this.$bus.$on("openDialogCrearActualizarCargos", (item) => {
      this.form = item;

      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogCrearActualizarCargos");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let user = this.$storage.get("user");
        try {
          this.form.denominacion = this.form.denominacion.toUpperCase();
          //formatear el numero:
          //verificar si hay decimales
          let existe_decimal = this.form.haber_basico.includes(".");

          if (existe_decimal) {
            this.form.haber_basico = this.form.haber_basico.replace(".", ",");
          }
          let existe_decimal2 = this.form.haber_basico.includes(",");

          if (existe_decimal2 == false) {
            this.form.haber_basico = this.form.haber_basico.toString() + ",00";
          }

          //formatear a decimal
          let haber=this.form.haber_basico.replace(",", ".");
          const opciones = {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          };
          const formatoNumero = new Intl.NumberFormat("en-US", opciones);
          const numeroFormateado = formatoNumero.format(haber);
          console.log(numeroFormateado); 

           this.form.haber_basico =(numeroFormateado.toString()).substring(1, numeroFormateado.length);
           let haber_copia=  this.form.haber_basico.split(".")
           this.form.haber_basico =(haber_copia[0].replace(",", "."))+","+haber_copia[1]

          ///////////////MODIFICACION O ALMACENAMIENTO DEL REGISTRO
          if (this.form.id_cargo) {
            //edito puesto
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select movilidad.fn_actualiza_cargo(${parseInt(
                  this.form.id_cargo
                )} ,'${this.form.denominacion}','${
                this.form.haber_basico
              }',${parseInt(user.id)})"){
                  respuesta
                }
              }
            `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_actualiza_cargo.split("|");
            if (respuesta[0] == "1") {
              this.$message.success("Registro modificado exitosamente");
            } else {
              this.$message.warning(respuesta[1]);
            }
          } else {
            //creo nuevo puesto
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select movilidad.fn_registra_cargo('${
                  this.form.denominacion
                }','${this.form.haber_basico}',${parseInt(user.id)})"){
                  respuesta
                }
              }
            `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_registra_cargo.split("|");
            if (respuesta[0] == "1") {
              this.$message.success("Registro creado exitosamente");
            } else {
              this.$message.warning(respuesta[1]);
            }
          }
        } catch (error) {
          console.log(error);
        }

        this.loading = false;
        this.close();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/item_cargo_y_puesto/dialogs/CrearActualizarCargos.vue